<button mat-button class="upload-btn" (click)="handleOpenDialog()" [class.uploading]="isActiveUpload">
  <span class="button-overlay" [style.width]="progressPercentage"></span>
  <mat-icon *ngIf="!isActiveUpload">file_upload</mat-icon>
  <mat-icon *ngIf="isActiveUpload">cached</mat-icon>
  <span class="label">Upload</span>
</button>